function MobileLayout({ children }) {

    return (

        <div className="page">

            <div className="mobile-layout">

                {children}

            </div>

        </div>

    );

}

export default MobileLayout;